import { useGenericRequestHandler } from '../../handlers/useGenericRequestHandler'

export const useConfirmCSVMutation = () => {
  return useGenericRequestHandler({
    route: `t/confirmCSV`,
    method: 'POST'
  })
}
